var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section-legal" }, [
    _c("h1", [_vm._v(_vm._s(_vm.$t("legal.title")))]),
    _c("div", { staticClass: "content" }, [
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.1")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.2")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.3")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.4")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.5")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.6")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.7")) } }),
      _c("h4", { domProps: { innerHTML: _vm._s(_vm.$t("legal.8")) } }),
      _c("h5", { domProps: { innerHTML: _vm._s(_vm.$t("legal.9")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.10")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.11")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.12")) } }),
      _c("h5", { domProps: { innerHTML: _vm._s(_vm.$t("legal.13")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.14")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.15")) } }),
      _c("h5", { domProps: { innerHTML: _vm._s(_vm.$t("legal.16")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.17")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.18")) } }),
      _c("h5", { domProps: { innerHTML: _vm._s(_vm.$t("legal.19")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.20")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.21")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.22")) } }),
      _c("h5", { domProps: { innerHTML: _vm._s(_vm.$t("legal.23")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.24")) } }),
      _c("h5", { domProps: { innerHTML: _vm._s(_vm.$t("legal.25")) } }),
      _c("h6", { domProps: { innerHTML: _vm._s(_vm.$t("legal.26")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.27")) } }),
      _c("h6", { domProps: { innerHTML: _vm._s(_vm.$t("legal.28")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.29")) } }),
      _c("h6", { domProps: { innerHTML: _vm._s(_vm.$t("legal.30")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.31")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.32")) } }),
      _c("h6", { domProps: { innerHTML: _vm._s(_vm.$t("legal.33")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.34")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.35")) } }),
      _c("h6", { domProps: { innerHTML: _vm._s(_vm.$t("legal.36")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.37")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.38")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.39")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.40")) } }),
      _c("h6", { domProps: { innerHTML: _vm._s(_vm.$t("legal.41")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.42")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.43")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.44")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.45")) } }),
      _c("h6", {
        attrs: { id: "remove-user" },
        domProps: { innerHTML: _vm._s(_vm.$t("legal.remove.user.title")) },
      }),
      _c("br"),
      _c(
        "ul",
        { staticStyle: { "list-style": "disc", "margin-left": "30px" } },
        [
          _c("li", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("legal.remove.user.content.1")),
            },
          }),
          _c("li", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("legal.remove.user.content.2")),
            },
          }),
        ]
      ),
      _c("br"),
      _c("p", {
        domProps: { innerHTML: _vm._s(_vm.$t("legal.remove.user.content.3")) },
      }),
      _c("h5", { domProps: { innerHTML: _vm._s(_vm.$t("legal.46")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.47")) } }),
      _c("h5", { domProps: { innerHTML: _vm._s(_vm.$t("legal.48")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.49")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.50")) } }),
      _c("h5", { domProps: { innerHTML: _vm._s(_vm.$t("legal.51")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.52")) } }),
      _c("h5", { domProps: { innerHTML: _vm._s(_vm.$t("legal.53")) } }),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("legal.54")) } }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }